import {HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {CommonService} from './common.service';
import {Resume} from '../components/resumes/resumes/models/Resume';
import {ResumeQuestion} from '../components/resumes/resumes/models/ResumeQuestion';

@Injectable({
  providedIn: 'root'
})
export class ResumeService {

  constructor(private commonService: CommonService) { }


  async downloadResume(params: {id: number, uniqueToken: string}): Promise<any> {
    const response = await this.commonService.getList(`resumes/completed/unique/export?id=${params.id}&uniqueToken=${params.uniqueToken}`);
    return response.object;
  }

  async fetchResumes(): Promise<Resume[]> {
    try {
      const resumes = await this.commonService.getList('resumes');
      return resumes.object;
    } catch (e) {
      throw e;
    }
  }

  async createTFA(params) {
    return await this.commonService.insertItem('resumes/tfa-create', params);
  }

  async confirmTFA(params) {
    return await this.commonService.insertItem('resumes/tfa-confirm', params);
  }

  async fetCompletedFormResults(uniqueId: string): Promise<any> {
    return await this.commonService.getList(`resumes/completed/${uniqueId}`);
  }

  async duplicateResume(id: number): Promise<any> {
    return await this.commonService.getList(`resumes/resume/duplicate/${id}`);
  }

  async fetchResumeColumns(uniqueId: string) {
    const columnsRequest = await this.commonService.getList(`resumes/resume/${uniqueId}/columns`);
    return columnsRequest.object;
  }

  async uploadFiles(formData, uniqueId, uniqueToken) {
    console.log('sending files');
    const headers = new HttpHeaders().set('content-type', 'multipart/form-data');
    return await this.commonService.insertItem(`resumes/submit-files?uniqueId=${uniqueId}&uniqueToken=${uniqueToken}`, formData);
  }

  async deleteForm(id: number) {
    return await this.commonService.deleteItem(`resumes/${id}`);
  }

  async fetchResumeById(id: number): Promise<any> {
    return await this.commonService.getList(`resumes/${id}`);
  }

  async fetchResumeByUniqueId(uniqueId: string): Promise<any> {
    const request = await this.commonService.getList(`resumes/unique/${uniqueId}`);
    return request.object;
  }

  async fetchResumeByUniqueTokenAndId(id: number, uniqueToken: string): Promise<any> {
    const request = await this.commonService.getList(`resumes/completed/unique?id=${id}&uniqueToken=${uniqueToken}`);
    return request.object;
  }

  async submitForm(form: any): Promise<any> {
    const response: any = await this.commonService.insertItem('resumes/submit', form);
    return response.object;
  }

  async updateForm(form: any): Promise<any> {
    const response: any = await this.commonService.updateItem('resumes/resubmit', form);
    return response.object;
  }

  async updateInternal(form: any) {
    await this.commonService.updateItem('resumes/resume/update', form);
  }

  async submitFormByUser(form: any) {
    await this.commonService.insertItem('resumes/submit', form);
  }

  async fetchQuestions(): Promise<ResumeQuestion[]> {
    try {
      const questionsRequest = await this.commonService.getList('resumes/questions');
      return questionsRequest.object;
    } catch (e) {
      throw e;
    }
  }

  //#region TableViews
  async fetchUserTableViews(model: string): Promise<any> {
    return await this.commonService.getList(`resumes/table-views/${model}`);
  }

  async setDefaultUserTableView(model: string, viewId): Promise<any> {
    return await this.commonService.updateItem(`resumes/table-views/${model}`, {viewId});
  }

  async storeUserTableView(view: any): Promise<any> {
    return await this.commonService.insertItem(`resumes/table-views`, {view});
  }

  async deleteUserTableView(viewId: number): Promise<any> {
    return await this.commonService.deleteItem(`resumes/table-views/${viewId}`);
  }

  async updateUserTableView(viewId: number, view: any): Promise<any> {
    return await this.commonService.insertItem(`resumes/table-views/${viewId}`, {view});
  }
  //#endregion
}
